import React, { useEffect, useState } from "react";
import Icon from "../../../components/icons";
import toast from "react-hot-toast";
import Button from "../../../components/elements/button";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";

interface Props {
    showOR?: boolean;
    facilitiess?: Array<any>;
    priorities?: Array<any>;
    onProcessing?: () => void; // Callback to handle captured audio data
    onCapture?: (data: any) => void; // Callback to handle captured audio data
};

const CollectAudioData: React.FC<Props> = ({ showOR = false, onCapture = (data: any) => { }, onProcessing = () => { }, facilitiess = [], priorities = [] }) => {
    const workRequestAPI: any = useWorkRequestApi();

    //const BACKEND_URL = "https://farm-chatbot-backend-d6f2bneug7a0baet.eastus2-01.azurewebsites.net/api/process_audio";
    //const SERVER_API_KEY = "XKEg8hmXVyafdbjzECALrFijyRpdQNfLKjK8mPNLJqcya6fIm0XbpsNK62kVajbZ"; // Replace with your actual key
    const jsonFields = [
        { name: "id", value: '' },
        { name: "description", allowedValues: [] },
        { name: "notes", allowedValues: [] },
        { name: "priorityIDs", allowedValues: priorities },
        { name: "facilityID", allowedValues: facilitiess },
        { name: "line", allowedValues: [] },
        { name: "zone", allowedValues: [] },
        { name: "workRequestStatusID", allowedValues: [] }
    ];

    const audioPlayer = React.useRef<HTMLAudioElement | null>(null);
    const audioContext = React.useRef<AudioContext | null>(null);
    const audioStream = React.useRef<MediaStream | null>(null);
    const audioRecorder = React.useRef<any>(null);

    const [audioData, setAudioData] = useState<Float32Array[]>([]);
    const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
    const [isRecording, setIsRecording] = useState(false);
    const [isShowPreview, setIsShowPreview] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    const exportWAV = (callback: any) => {
        const mergedBuffers = mergeBuffers(audioData);
        const sampleRate = audioContext.current?.sampleRate;
        const dataview = encodeWAV(mergedBuffers, sampleRate);
        const audioBlob = new Blob([dataview], { type: 'audio/wav' });
        callback(audioBlob);
    }
    const mergeBuffers = (bufferArray: any[]) => {
        let totalLength = 0;
        bufferArray.forEach(buffer => { totalLength += buffer.length; });
        let result = new Float32Array(totalLength);
        let offset = 0;
        bufferArray.forEach(buffer => { result.set(buffer, offset); offset += buffer.length; });
        return result;
    }
    const encodeWAV = (samples: any, sampleRate: any) => {
        let buffer = new ArrayBuffer(44 + samples.length * 2);
        let view = new DataView(buffer);
        writeString(view, 0, 'RIFF'); view.setUint32(4, 36 + samples.length * 2, true); writeString(view, 8, 'WAVE');
        writeString(view, 12, 'fmt '); view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
        view.setUint32(24, sampleRate, true); view.setUint32(28, sampleRate * 2, true); view.setUint16(32, 2, true);
        view.setUint16(34, 16, true); writeString(view, 36, 'data'); view.setUint32(40, samples.length * 2, true);
        let offset = 44;
        for (let i = 0; i < samples.length; i++, offset += 2) {
            let s = Math.max(-1, Math.min(1, samples[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
        return view;
    }
    const writeString = (view: any, offset: any, string: any) => {
        for (let i = 0; i < string.length; i++) {
            view.setUint8(offset + i, string.charCodeAt(i));
        }
    }

    useEffect(() => {
        console.log("facilitiess changed...", facilitiess);
    }, [facilitiess]);

    return (
        <div className={`mb-8`}>
            {!isRecording ? (
                <div className={`flex flex-col gap-3 items-center justify-center h-28 bg-gray-100 border-2 border-dashed border-gray-400 mt-5 mr-1 rounded-sm cursor-pointer`} onClick={async () => {
                    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                        toast.error('Your browser does not support audio recording.');
                        return;
                    }
                    try {
                        var adx: Float32Array[] = [];
                        audioContext.current = new (window.AudioContext || (window as any).webkitAudioContext)();
                        audioStream.current = await navigator.mediaDevices.getUserMedia({ audio: true });
                        const source = audioContext.current.createMediaStreamSource(audioStream.current);
                        audioRecorder.current = audioContext.current.createScriptProcessor(4096, 1, 1);
                        audioRecorder.current.onaudioprocess = (e: any) => {
                            adx.push(new Float32Array(e.inputBuffer.getChannelData(0)));
                            setAudioData(adx);
                        };
                        source.connect(audioRecorder.current);
                        audioRecorder.current.connect(audioContext.current.destination);
                        setIsRecording(true);
                        setIsShowPreview(false);
                    } catch (error) {
                        setIsRecording(false);
                        setIsShowPreview(false);
                        console.error("Error accessing microphone:", error);
                        toast.error("Could not access the microphone. Please grant permission.");
                    }
                }}>
                    <div className={`text-gray-600`}><Icon name={`mic`} size={1.9} /></div>
                    <div className={`text-gray-800 font-light`}>Using voice populate form</div>
                </div>
            ) : (
                <div className={`flex flex-col items-center justify-center gap-2 h-28 bg-gray-100 border-2 border-dashed border-gray-400 mt-5 mr-1 rounded-sm`}>
                    <div id="status" className="flex items-center justify-center space-x-2 h-6 mb-0 text-gray-600">
                        <div className="recording-indicator"></div>
                        <p>Recording...</p>
                    </div>
                    <div>
                        <Button theme={`danger`} customstyle={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `10px`, paddingRight: `8px` }} onClick={() => {
                            if (audioRecorder.current && audioStream.current && audioContext.current) {
                                audioRecorder.current.disconnect();
                                audioStream.current.getTracks().forEach(track => track.stop());
                                audioContext.current.close().then(() => {
                                    exportWAV(async (blob: any) => {
                                        setAudioBlob(blob);

                                        //Needs to do processing of audio blob
                                        /* if (!SERVER_API_KEY) {
                                            toast.error('Please set the SERVER_API_KEY constant in the script.');
                                            return;
                                        } */
                                        if (!blob) {
                                            toast.error('No audio has been recorded yet.');
                                            return;
                                        }
                                        if (jsonFields.length === 0) {
                                            alert('You must define at least one JSON field.');
                                            return;
                                        }
                                        const generateUniqueId = () => {
                                            const timestamp = Date.now();
                                            const letters = Array.from({ length: 3 }, () =>
                                                String.fromCharCode(65 + Math.floor(Math.random() * 26)) // 65–90 => A–Z
                                            ).join("");
                                            return `${letters}_${timestamp}`;
                                        };
                                        const generatedId = generateUniqueId();
                                        const formData = new FormData();
                                        const key = jsonFields.findIndex((o: any) => o.name === "id");
                                        if (key > -1) {
                                            jsonFields[key].value = generatedId;
                                        } else {
                                            jsonFields.push({ name: "id", value: generatedId });
                                        }
                                        formData.append('audio', blob, 'incident.wav');
                                        formData.append('config', JSON.stringify(jsonFields));
                                        //formData.append('api_key', SERVER_API_KEY);
                                        try {
                                            onProcessing(); // Call the processing callback
                                            /* const response = await fetch(BACKEND_URL, {
                                                method: 'POST',
                                                body: formData,
                                            });
                                           
                                            var data = await response.json();
                                            if (!response.ok) {
                                                throw new Error(data.error || `Server error: ${response.status}`);
                                            }
                                            if (data.error === -1) {
                                                throw new Error("The backend could not connect to the AI. Check the server configuration.");
                                            }
                                            if (data.error === -2) {
                                                throw new Error("Processing failed: The audio file is longer than the server's allowed limit.");
                                            }
                                            console.log("Data Processing final data is... -> ", data)
                                            for await (const field of Object.keys(data)) {
                                                if (data[field] === `null`) data[field] = null;
                                            } */
                                            // Add the generated ID to the response data since backend doesn't return it
                                            workRequestAPI.ProcessAudio(formData, async (resp: any) => {
                                                //toast.success(resp?.message)
                                                var data = resp;

                                                data["id"] = generatedId;
                                                if (data && blob) {
                                                    // Convert Blob to File for binary upload if needed
                                                    const file = new File([blob], "incident.wav", { type: "audio/wav" });
                                                    console.log("Converted Blob to File:", file);
                                                    data["recordfile"] = file;
                                                    onCapture(data);
                                                    console.log("Final data to capture is... -> ", data);
                                                }
                                            }, (error: any) => {
                                                toast.error(error?.message || "An error occurred while processing audio.");
                                            });
                                            //data[`recordfile`] = blob;
                                           
                                        } catch (error: any) {
                                            onCapture(null);
                                            console.error('Error processing audio:', error);
                                            let errorMessage = `An error occurred: ${error.message}`;
                                            if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
                                                errorMessage = `Could not connect to the backend. Please ensure the Python server is running `;
                                            }
                                            toast.error(errorMessage);
                                        } finally {

                                        }
                                        //audioBlob = blob;                                        

                                        const audioUrl = URL.createObjectURL(blob);
                                        if (audioPlayer.current) {
                                            audioPlayer.current.src = audioUrl;
                                        }
                                        setIsShowPreview(true);

                                    });
                                });
                                setIsRecording(false);
                            }
                        }}>
                            <Icon name={`stop`} size={1} /> Stop
                        </Button>
                    </div>
                </div>
            )}
            <audio ref={audioPlayer} id="audioPlayer" controls className="hidden" onEnded={() => {
                setIsPlaying(false);
                if (audioPlayer.current) {
                    audioPlayer.current.currentTime = 0;
                }
            }} />
            {isShowPreview && (
                <div className={`bg-lime-800 text-white p-2 relative h-12 flex items-center justify-between`}>
                    <div className={`font-light`}>Preview</div>
                    <div>
                        {!isPlaying ? (
                            <button className={`w-12 h-12 bg-transparent border-0 outline-0 absolute right-14 bottom-[-15px]`} onClick={() => {
                                if (audioPlayer.current) {
                                    audioPlayer.current.pause();
                                    audioPlayer.current.currentTime = 0;
                                    audioPlayer.current.play();
                                    setIsPlaying(true);
                                }
                            }}>
                                <svg height="40px" width="40px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.00 58.00" xmlSpace="preserve" fill="" stroke="" stroke-width="0.00058"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.11599999999999999"></g><g id="SVGRepo_iconCarrier"> <circle style={{ fill: "#EBBA16" }} cx="29" cy="29" r="29"></circle> <g> <polygon style={{ fill: "#FFFFFF" }} points="44,29 22,44 22,29.273 22,14 "></polygon> <path style={{ fill: "#FFFFFF" }} d="M22,45c-0.16,0-0.321-0.038-0.467-0.116C21.205,44.711,21,44.371,21,44V14 c0-0.371,0.205-0.711,0.533-0.884c0.328-0.174,0.724-0.15,1.031,0.058l22,15C44.836,28.36,45,28.669,45,29s-0.164,0.64-0.437,0.826 l-22,15C22.394,44.941,22.197,45,22,45z M23,15.893v26.215L42.225,29L23,15.893z"></path> </g> </g></svg>
                            </button>
                        ) : (
                            <button className={`w-12 h-12 bg-transparent border-0 outline-0 absolute right-14 bottom-[-15px]`} onClick={() => {
                                if (audioPlayer.current) {
                                    audioPlayer.current.pause();
                                    audioPlayer.current.currentTime = 0;
                                    setIsPlaying(false);
                                }
                            }}>
                                <svg fill="" width="46px" height="46px" viewBox="0 0 24.00 24.00" id="stop-circle" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" className="icon flat-color" stroke="" stroke-width="0.00024000000000000003"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.048"></g><g id="SVGRepo_iconCarrier"><circle id="primary" cx="12" cy="12" r="10" style={{ fill: "#ebba16" }}></circle><rect id="secondary" x="9" y="9" width="6" height="6" rx="1" transform="translate(24) rotate(90)" style={{ fill: "#fcfdfd" }}></rect></g></svg>
                            </button>
                        )}
                    </div>
                </div>
            )}
            {showOR && (<div className={`text-gray-500 font-normal relative flex items-center justify-center gap-3 after:bg-gray-200 after:contents-[""] after:flex after:h-[1px] after:w-32 before:bg-gray-200 before:contents-[""] before:flex before:items-center before:h-[1px] before:w-32 mt-8`}>OR</div>)}
        </div>
    )
}
export default CollectAudioData;